import { useState } from "react";
import { collections } from "@/mocks/heigua";
import SectionHeading from "./SectionHeading";

const tabMeta: Record<string, string> = {
  annual: "年度总复习",
  showcase: "综艺名场面",
  reverse: "反转与澄清",
  starter: "考古入门",
};

export default function Collections() {
  const [activeKey, setActiveKey] = useState(collections[0].key);
  const active = collections.find((c) => c.key === activeKey) ?? collections[0];

  return (
    <section id="collections" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          index="叁"
          eyebrow="Classic Box"
          title="经典合集 · 打包翻旧料"
          subtitle="同类旧料按主题打包成合集，一次性补完一整类。切换下方档案夹，看看想从哪套开始。"
        />

        {/* Tab 切换 */}
        <div className="mt-8 flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-100 p-1.5 sm:inline-flex sm:flex-nowrap">
          {collections.map((c) => {
            const isActive = c.key === activeKey;
            return (
              <button
                key={c.key}
                type="button"
                onClick={() => setActiveKey(c.key)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {tabMeta[c.key]}
              </button>
            );
          })}
        </div>

        {/* 合集展示 */}
        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="relative aspect-[4/3] overflow-hidden rounded-lg border border-background-200">
              <img
                src={active.image}
                alt={`${active.title}经典合集封面`}
                className="h-full w-full object-cover"
              />
              <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-700">
                {active.count} · 持续归档
              </span>
            </div>
          </div>

          <div className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6 lg:col-span-3 lg:p-8">
            <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {active.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {active.summary}
            </p>

            <ul className="mt-6 flex flex-col divide-y divide-background-200">
              {active.picks.map((p, i) => (
                <li key={p}>
                  <a href="#featured" className="group flex items-center gap-3 py-3.5">
                    <span className="font-heading text-lg font-bold text-primary-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                      {p}
                    </span>
                    <i className="ri-arrow-right-line text-foreground-400 transition-colors group-hover:text-primary-600" />
                  </a>
                </li>
              ))}
            </ul>

            <a
              href="#library"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400 sm:w-auto sm:self-start"
            >
              进档案库查看《{active.title}》
              <i className="ri-archive-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}